import * as React from "react";
import { PaginationQuery, PaginationState } from "~/modules/filters/types";

// // // //

interface Props {
    loading?: boolean;
    paginationState: PaginationState;
    onChange: (updatedPagination: PaginationQuery) => void;
}

// // // //

/**
 * Renders dropdown to change PaginationState.itemsPerPage
 * NOTE - currently only renders on XL screen sizes
 */
export function ItemsPerPageSelect(props: Props) {
    const { loading = false, paginationState, onChange } = props;
    const { perPage, resultCount } = paginationState;

    // Return null if the total count of results is less than the smallest page size
    if (resultCount <= 10) {
        return null;
    }

    return (
        <>
            <div className="hidden xl:flex items-center gap-2">
                <p className="font-light text-slate-600 whitespace-nowrap">
                    Results per page
                </p>

                <select
                    disabled={loading}
                    value={perPage}
                    className="flex w-full py-0 rounded-md border-0 text-foreground ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => {
                        const newPerPage = parseInt(e.currentTarget.value);

                        onChange({
                            page: 1,
                            perPage: newPerPage,
                        });
                    }}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    {/* QUESTION - how can we monitor the performance hit of these queries? */}
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                </select>
            </div>
            <p className="text-slate-500 px-2 font-extralight hidden xl:block">
                |
            </p>
        </>
    );
}
